import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const navLinks = [
  { label: '首页', to: '/' },
  { label: '题材分类', to: '/category/romance' },
  { label: '热门韩漫', to: '/#popular' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [query, setQuery] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = query.trim();
    if (!q) return;
    // 简单跳转到分类页并携带查询
    window.location.hash = '#popular';
    setMenuOpen(false);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 transition-all duration-300">
      <nav
        className={`px-4 md:px-6 transition-colors duration-300 ${
          scrolled || menuOpen ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="漫画韩漫网址首页">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-palette-line text-lg md:text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">
              漫画韩漫<span className="text-primary-600">网址</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <NavLink
                key={link.label}
                to={link.to}
                className={({ isActive }) =>
                  `text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive && link.to.startsWith('/category')
                      ? 'text-primary-600'
                      : 'text-foreground-700 hover:text-primary-600'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <input
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索你想看的韩漫..."
                aria-label="搜索韩漫"
                className="w-52 h-10 pl-9 pr-4 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400" aria-hidden="true"></i>
            </form>
            <Link
              to="/category/romance"
              className="h-10 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-medium flex items-center justify-center whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              浏览题材
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-800 hover:bg-background-100"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50/98 px-4 pt-2 pb-4">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  onClick={() => setMenuOpen(false)}
                  className="px-3 py-3 rounded-lg text-foreground-700 hover:bg-background-100 hover:text-primary-600 text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <form onSubmit={handleSearch} className="relative mt-3">
              <input
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索你想看的韩漫..."
                aria-label="搜索韩漫"
                className="w-full h-11 pl-9 pr-4 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400" aria-hidden="true"></i>
            </form>
          </div>
        )}
      </nav>
    </header>
  );
}